import { GPTGameNameType } from '../games';
import {
  DailyBonusIcon,
  GPTGameIcon,
  LuckyCardIcon,
  LuckyPigeonIcon,
  WheelOfFortuneIcon
} from '../icons';

export const GPT_BANNERS_CONFIG: Partial<
  Record<GPTGameNameType, { Icon: GPTGameIcon; title: string }>
> = {
  cardGame: {
    Icon: LuckyCardIcon,
    title: 'gpt.luckyCardTitle'
  },
  wheelOfFortune: {
    Icon: WheelOfFortuneIcon,
    title: 'gpt.wheelOfFortuneTitle'
  },
  dailyBonus: {
    Icon: DailyBonusIcon,
    title: 'gpt.dailyBonusTitle'
  },
  birdGame: {
    Icon: LuckyPigeonIcon,
    title: 'gpt.luckyPigeonTitle'
  }
};
